import React from 'react'
import {IconRow} from './icon-row'
import {useIntl} from 'react-intl'
import useMultiSite from '../../hooks/use-multi-site'
import {usePaymentIcons} from '../../hooks/useScapiCustomApi'
import {useD2BCustomer} from '../../hooks/use-d2b-customer'
import {CUSTOMER_TYPE_B2C, CUSTOMER_TYPE_D2B} from '../../constants'

export const PaymentIcons = (props) => {
    const intl = useIntl()
    const {locale} = useMultiSite()
    const isD2BEnabled = useD2BCustomer().enabled
    const {data: paymentMethods} = usePaymentIcons(
        {
            parameters: {
                locale: locale.id,
                c_channelType: isD2BEnabled ? CUSTOMER_TYPE_D2B : CUSTOMER_TYPE_B2C
            }
        },
        {}
    )

    if (!paymentMethods?.icons?.length) {
        return null
    }

    return (
        <IconRow
            {...props}
            icons={paymentMethods.icons}
            title={intl.formatMessage({
                id: 'payment-icons.pay_with',
                defaultMessage: 'Pay easily via:'
            })}
        />
    )
}

export default PaymentIcons
